@if (canShow() && !mobileMode()) {
    <div class="header top-margin" [class.active]="isAreaBuilderActive">
        <ev-tooltip-simple class="tooltip" text="Områdevelger"></ev-tooltip-simple>
    </div>
}

@if (canShow()) {
    <div
        class="map-button solid draw-menu"
        [ngClass]="{
            active: polygonState?.drawStates.isActivated && !polygonState?.drawStates.isMoveMode,
            'out-zoomed': !polygonState?.drawStates.canUsePolyDraw,
        }"
        (click)="onFreedrawMenuClick()"
    >
        @if (!mobileMode()) {
            <ev-tooltip-simple class="tooltip" text="Tegn område"></ev-tooltip-simple>
        }
    </div>

    <div
        class="map-button solid draw-polygon"
        [ngClass]="{
            active: polygonState?.drawStates.isActivated && !polygonState?.drawStates.isMoveMode,
            'out-zoomed': !polygonState?.drawStates.canUsePolyDraw,
            'move-mode': polygonState?.drawStates.isMoveMode,
        }"
        (click)="onDrawModeClick()"
    >
        @if (!mobileMode()) {
            <ev-tooltip-simple class="tooltip" text="Tegn område"></ev-tooltip-simple>
        }

        <div
            class="map-button pencil-animation"
            [ngClass]="{
                active: polygonState?.drawStates.isActivated,
                'out-zoomed': !polygonState?.drawStates.canUsePolyDraw,
                'move-mode': polygonState?.drawStates.isMoveMode,
            }"
        ></div>
        <div [ngClass]="{ line: !polygonState?.drawStates.isMoveMode }"></div>
    </div>

    <div class="map-button solid" (click)="onAreaBuilderClick()">
        <div class="map-button areabuilder"></div>
        @if (!mobileMode()) {
            <ev-tooltip-simple class="tooltip" text="Velg område"></ev-tooltip-simple>
        }
    </div>
}
@if (canShow() && (mobileMode() || polygonState?.drawStates.isActivated || polygonState?.drawStates.canRevert)) {
    <div class="map-button solid" [ngClass]="{ canTrash: polygonState?.drawStates.canRevert }" (click)="onRevertClick()">
        <div class="map-button trash" [ngClass]="{ canTrash: polygonState?.drawStates.hasPolygons || mobileMode() }"></div>
    </div>
}
